import React from "react";

const Synopsis = () => {
  return (
    <div>
      <p>
        <strong>
          <i>Study Status:</i>
        </strong>{" "}
        IRB Approved, Data Collection, Data Analysis
        <br />
        <br />
        <strong>
          <i>Study Design:</i>
        </strong>{" "}
        <br />
        Edinburgh Cognitive and Behavioral ALS Screen (ECAS) ​ <br />
        The ECAS is a practical screening tool that incorporates a range of
        short cognitive tests that have been shown to be sensitive to
        cognitive impairment in ALS. The ECAS has been designed to
        differentiate between the different profiles common with aging
        including depression, Alzheimer’s disease and Frontotemporal Dementia.
        Executive Functions, Memory, Language, Visuospatial skills and Social
        cognition are specifically assessed whilst a Behavioural and Psychosis
        brief interview can be carried out with carers or relatives. The ECAS
        is designed for ALS patients and answers can be given verbally, or by
        a combination of writing or pointing. It is suitable for patients who
        are anarthric or patients who have no hand motor function. It is
        typically given in person at clinic visits. With EverythingALS’s novel
        method of collecting data, the ECAS is now available to participants
        in the convenience of their own homes.
        <br />
        <br />
        <strong>
          <i>Recruitment:</i>
        </strong>
        <br /> Ongoing
      </p>
    </div>
  );
};

export default Synopsis;
